import PlaceConfig from "./PlaceConfig";
import AuthService from "../auth/AuthService"
export default class PlaceService {
  /******* PLACES **********/
  static getPlaces(app) {
    
    return new Promise(async (resolve, reject) => {
      try{
        
        let token = await AuthService.getToken()
        let endpoint = PlaceConfig.endpointPlaces;
        let response = await PlaceConfig.APIConnector.get(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
        });
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static savePlace(app,place) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = PlaceConfig.endpointSavePlace;
        let response = await PlaceConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify(place)
        });
        // console.log("RESPONSE SAVE PLACE",response)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static deletePlace(app,placeId) {
    return new Promise(async (resolve, reject) => {
      try{
        let token = await AuthService.getToken()
        let endpoint = PlaceConfig.endpointDeletePlace;
        let response = await PlaceConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body:JSON.stringify({id:placeId})
        });
        // console.log("RESPONSE DELETE Place",response, placeId)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  /******** FIN PLACES *********/
}


// WEBPACK FOOTER //
// ./src/provider/place/PlaceService.js